import { useTranslation } from 'react-i18next';

/**
 * Suspense fallback for lazy routes rendered INSIDE the AppShell. It fills the
 * main content area (never a blank main) while the route chunk loads — the shell
 * chrome stays put, so navigation feels instant even on a slow network.
 */
export function RouteFallback() {
  const { t } = useTranslation();
  return (
    <div className="mx-auto w-full px-5 py-8 sm:px-6 lg:py-10">
      <span className="sr-only" role="status">
        {t('app.loading')}
      </span>
      <div className="flex flex-col gap-2.5" aria-hidden="true">
        {[0, 1, 2].map((i) => (
          <div key={i} className="min-h-16 animate-pulse rounded-panel border border-raad-border bg-raad-panel" />
        ))}
      </div>
    </div>
  );
}
